/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import validator from 'validator';
import RequestReports from '../../components/reports/RequestReports';
import { requestReport } from '../../components/FormDefaultValues';
import {
  searchData, getUserData, getIdToken, getAccessToken, isAuthenticated, getLoginUrl,
} from '../../utility/common';
import submitRequestReportForm from '../../actions/reports/RequestReport';
import { successMessage, errorMessage } from '../../constants/Constants';

// eslint-disable-next-line react/jsx-props-no-spreading
const RequestReportContainer = (props) => {
  const [isNewReport, setNewReport] = useState(false);
  const [data, setData] = useState(requestReport);
  const [fieldsError, setFieldsError] = useState({
    reportNameField: false,
    nameField: false,
    emailField: false,
    descriptionField: false,
  });
  const [message, setMessage] = useState(null);
  const userData = getUserData();
  const { dn } = userData;
  const dashboardData = useSelector((state) => state.getDashboardList);
  const requestResponse = useSelector((state) => state.requestReportSubmit);
  const { isRRSending, rRError, isRRSuccess } = requestResponse;
  const { dashboardListData } = dashboardData;
  useEffect(() => {
    if (isRRSuccess) {
      setMessage(successMessage);
      setFieldsError({
        reportNameField: false,
        nameField: false,
        emailField: false,
        descriptionField: false,
      });
      setNewReport(false);
      setData(requestReport);
    }
    if (rRError) {
      setMessage(errorMessage);
    }
  }, [isRRSuccess, rRError]);

  const handleChange = (event) => {
    const { value, name } = event.target;
    const error = { ...fieldsError };
    const newData = { ...data };
    if (validator.isEmpty(value) || (name === 'email' && !validator.isEmail(value))) {
      error[`${name}Field`] = true;
    } else {
      error[`${name}Field`] = false;
    }
    if (name === 'name' && validator.isLength(value, { min: 1 }) && !validator.isAlpha(value, 'en-US', { ignore: ' -' })) {
      return false;
    }
    if (name === 'description' && validator.isLength(value, { min: 3001 })) {
      return false;
    }
    setFieldsError(error);
    newData[name] = value;
    setData(newData);
  };

  const handleRadioButton = (event) => {
    const { value } = event.target;
    const newData = { ...requestReport };
    newData.reportType = value;
    if (value === 'New Report') {
      setNewReport(true);
    } else {
      setNewReport(false);
    }
    setFieldsError({
      reportNameField: false,
      nameField: false,
      emailField: false,
      descriptionField: false,
    });
    setData(newData);
  };

  const getReportListArray = () => {
    let listOptions = [];
    if (dashboardListData !== null && Array.isArray(dashboardListData) && dashboardListData.length > 0) {
      listOptions = searchData(dashboardListData);
    }
    return listOptions;
  };

  const validateForm = () => {
    let reportTypeValid = true;
    let nameFieldValid = true;
    let emailFieldValid = true;
    let reportNameValid = true;
    let descriptionValid = true;
    if (validator.isEmpty(data.reportType)) {
      reportTypeValid = false;
    }
    if (validator.isEmpty(data.name)) {
      nameFieldValid = false;
    }
    if (!validator.isEmail(data.email)) {
      emailFieldValid = false;
    }
    if (validator.isEmpty(data.reportName)) {
      reportNameValid = false;
    }
    if (validator.isEmpty(data.description)) {
      descriptionValid = false;
    }
    setFieldsError({
      reportNameField: !reportNameValid,
      nameField: !nameFieldValid,
      emailField: !emailFieldValid,
      descriptionField: !descriptionValid,
    });
    return (reportTypeValid && nameFieldValid && emailFieldValid && reportNameValid && descriptionValid);
  };

  const submitForm = (event) => {
    if (!isAuthenticated()) {
      // eslint-disable-next-line no-undef
      window.location.href = getLoginUrl();
      return null;
    }
    const isFormValid = validateForm();
    if (isFormValid) {
      const number = Math.round(new Date().getTime() / 1000);
      const key = `Req-${dn}-${number}`;
      data.dn = dn;
      data.requestNo = key;
      data.createdDate = new Date();
      const requestParams = {
        openIdToken: getIdToken(),
        accessToken: getAccessToken(),
        data,
      };
      props.submitRequestReportForm(requestParams);
    }
    event.preventDefault();
    return false;
  };

  const resetForm = () => {
    setNewReport(false);
    setFieldsError({
      reportNameField: false,
      nameField: false,
      emailField: false,
      descriptionField: false,
    });
    setData(requestReport);
  };

  const handleMessage = () => {
    setMessage(null);
  };

  const handleBlur = (event) => {
    const { value, name } = event.target;
    const error = { ...fieldsError };
    if (validator.isEmpty(value) || (name === 'email' && !validator.isEmail(value))) {
      error[`${name}Field`] = true;
    } else {
      error[`${name}Field`] = false;
    }
    setFieldsError(error);
  };

  // eslint-disable-next-line consistent-return
  const handleSearch = (event, searchValue) => {
    const error = { ...fieldsError };
    const newData = { ...data };
    error.reportNameField = false;
    if (!searchValue) {
      newData.reportName = '';
      error.reportNameField = true;
    }
    if (searchValue) {
      const searchReport = _.filter(searchData(dashboardListData), (elem) => elem.Name === searchValue.Name);
      if (searchReport <= 0) {
        error.reportNameField = true;
        newData.reportName = '';
        return false;
      }
      newData.reportName = searchValue.Name;
    }
    setData(newData);
    setFieldsError(error);
  };

  const handleSearchClose = (event) => {
    const { name } = event.target;
    const error = { ...fieldsError };
    if (name && !validator.isEmpty(name)) {
      error.reportNameField = true;
    } else {
      error.reportNameField = false;
    }
    setFieldsError(error);
  };
  return (
    <RequestReports
      isNewReport={isNewReport}
      handleChange={(event) => handleChange(event)}
      handleRadioButton={(event) => handleRadioButton(event)}
      submitForm={(event) => submitForm(event)}
      resetForm={() => resetForm()}
      reportData={data}
      reportListData={getReportListArray()}
      isRRSending={isRRSending}
      rRError={rRError}
      isRRSuccess={isRRSuccess}
      message={message}
      handleMessage={() => handleMessage()}
      fieldsError={fieldsError}
      handleBlur={(event) => handleBlur(event)}
      handleSearch={(event, searchValue) => handleSearch(event, searchValue)}
      handleSearchClose={(event) => handleSearchClose(event)}
    />
  );
};

const mapDispatchedToProps = {
  submitRequestReportForm,
};

RequestReportContainer.propTypes = {
  submitRequestReportForm: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchedToProps)(RequestReportContainer);
